import { render, staticRenderFns } from "./invitations.vue?vue&type=template&id=81a1455c&scoped=true"
import script from "./invitations.vue?vue&type=script&lang=js"
export * from "./invitations.vue?vue&type=script&lang=js"
import style0 from "./invitations.vue?vue&type=style&index=0&id=81a1455c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a1455c",
  null
  
)

export default component.exports